module.exports = __webpack_public_path__ + "static/media/edit-24px.94f6e29d.svg";